import { useEffect, useState } from 'react';
import './lsc.scss';
import userApi from 'apis/userApi';
import classNames from 'classnames';

interface Props {
    onClose: () => void;
}

interface listHisMini {
    id: string;
    issue: string;
    bettime: any;
    txtBet: string;
    winnumber: string;
    amount: number;
    bonus: number;
    statusname: string;
    status: string;
}

export default function LSCBCMiniGame(props: Props) {
    const { onClose } = props;

    const [totalNum, setTotalNum] = useState<number>(0);
    const [tamount, setTamount] = useState<number>(0);
    const [twin, setTwin] = useState<number>(0);
    const [listHis, setListHis] = useState<listHisMini[]>([]);

    const formatDate = (valueDate: any) => {
        if (valueDate < 10) {
            valueDate = `0${valueDate}`;
        }
        return valueDate;
    }
    const submit = async () => {
        const currentDate = new Date();
        let starttime = new Date(currentDate);
        starttime.setDate(starttime.getDate() - 35);
        let formattedStartTime = starttime.getFullYear() + '/' + formatDate(starttime.getMonth() + 1) + '/' + formatDate(starttime.getDate()) + ' 00:00:00';
        const param = {
            lotteryid: 404,
            starttime:
              formattedStartTime.includes('T')
                ? formattedStartTime.replace(/T/g, ' ').substr(0, 19)
                : formattedStartTime.replace(/\//g, '-').substr(0, 19),
          };

          try {
            const { data } = await userApi.lotteryRecordBean('btnSearch', param);
            if (!data.msg) {
                const getResList = data["reslist"];
                setListHis(getResList);
                setTotalNum(data["totalrecord"]);
                setTamount(data["tamount"]);
                setTwin(data["twin"]);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        submit();
    }, []);

    return (
        <>
            <div id="lscBC">
                <section className="MiniGames BauCua1GiayGame">
                    <div className="historyBetUser layui-layer-wrap">
                        <h3 className="title">LỊCH SỬ CƯỢC</h3>
                        <div className="closeHis" onClick={onClose}>
                            <img src={require(`assets/images/txcanban/statis/close.png`)} alt='' />
                        </div>
                        <div className="inner">
                                <ul className="totalbet">
                                    <li>
                                        Tổng Cược: <strong>{ Number(tamount) }</strong>
                                    </li>
                                    <li>
                                        Tổng Trúng: <strong>{ Number(twin) }</strong>
                                    </li>
                                    <li>
                                        Số Lượt Chơi: <strong>{ totalNum }</strong>
                                    </li>
                                </ul>
                            <div className="content">
                                <div className="innerTblScroll">
                                    <table className="table-history">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Lượt xổ</th>
                                                <th>Thời gian</th>
                                                <th>Kết quả</th>
                                                <th>Cược</th>
                                                <th>Thắng</th>
                                                <th>Trạng thái</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                                {listHis.length === 0 ? (
                                                    <tr>
                                                        <td>Không có dữ liệu</td>
                                                    </tr>
                                                ) : (
                                                    listHis.map((item, idx) => (
                                                        <tr key={idx}>
                                                            <td>{ item.id }</td>
                                                            <td>{ item.issue }</td>
                                                            <td>{ item.bettime }</td>
                                                            <td className="oneLineVi">
                                                            {item.winnumber 
                                                                ? item.winnumber.split('').slice(0, 3).map((char, index) => (
                                                                    <img 
                                                                    key={index} 
                                                                    src={require(`assets/images/mini-bc/ico-${char}-w.svg`)} 
                                                                    alt="" 
                                                                    />
                                                                ))
                                                                : "-"}
                                                            </td>
                                                            <td>{ Number(item.amount) }</td>
                                                            <td className={classNames("win", { bonus: item.bonus > 0 })}>{ item.bonus }</td>
                                                            <td>
                                                                <span className={`state state-${item.status}`}>{item.statusname}</span></td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
